export const USERS = {
    login: "login",
    createEmpleado: "createEmpleado",
    getEmpleados: "getEmpleados",
    updateEmpleado: "updateEmpleado",
    detalleEmpleado: "detalleEmpleado",

    presignContrato: (numeroEmpleado) => `updateEmpleado/${numeroEmpleado}/presignContrato`,
    attachContrato: (numeroEmpleado) => `updateEmpleado/${numeroEmpleado}/attachContrato`,
};

export const CHECADOR = {
    getChecador: "getChecador",
    getChecadorPorEmpleado: (numeroEmpleado) => `getChecador?employeeNumber=${encodeURIComponent(numeroEmpleado)}`,
    getChecadorPorRango: (startDate, endDate) => `getChecador?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`,
}
